
module.exports = {
  /**
   * @description 网站标题
   */
  title: '智慧停车管理平台',
  /**
   * @description 是否显示 tagsView
   */
  tagsView: true,
  /**
   * @description 固定头部
   */
  fixedHeader: true,
  /**
   * @description 记住密码状态下的token在Cookie中存储的天数，默认1天
   */
  tokenCookieExpires: 365,
  /**
   * @description 记住密码状态下的密码在Cookie中存储的天数，默认1天s
   */
  passCookieExpires: 1,
  /**
   * @description 是否只保持一个子菜单的展开
   */
  uniqueOpened: true,
  /**
   * @description token key
   */
  TokenKey: 'SMART-TOKEN',
  /**
   * @description 请求超时时间，毫秒（默认2分钟）
   */
  timeout: 1200000,
  /**
   * @description 是否显示logo
   */
  sidebarLogo: true,
  /**
   * 是否显示设置的底部信息
   */
  showFooter: false,
  /**
   * 底部文字，支持html语法
   */
  footerTxt: '',
  /**
   * 备案号
   */
  caseNumber: '',

  /**
   * 指定备案号 东山
   */
  dsCaseNumber: '闽ICP备2022015222号-1',

  /**
   * 指定备案号 云霄建发
   */
  yxjfCaseNumber: '闽ICP备2022015222号-1',

  /**
   * 指定备案号 邵武
   */
  swCaseNumber: '闽ICP备2022016582号-1',

  /** 京山 */
  jsCaseNumber: '粤ICP备20060608号',

  /** 闽侯 */
  mhCaseNumber: '福州市联创智云信息科技有限公司',

  /** 仁怀 */
  rhCaseNumber: '粤ICP备20060608号-1',

  /** 遵义智城 */
  zyCaseNumber: '黔ICP备2022007372号-1',

  /** 云泊停 */
  ybCaseNumber: '粤ICP备20060608号-1',

  /** 福安 **/
  faCaseNumber: '闽ICP备2025104368号-2',

  /** 福安闽侯 **/
  fzmhCaseNumber: '粤ICP备20060608号',

  /** 云霄 */
  yxCaseNumber: '粤ICP备20060608号',

  /** 马尾 */
  mwCaseNumber: '粤ICP备20060608号',

  /** 乐控 */
  lkCaseNumber: '粤ICP备20060608号',

  /** 湖里 */
  hlCaseNumber:'闽ICP备20014232号-1',

  /** 中堂 */
  ztCaseNumber:'粤ICP备20060608号',

  /** 虎门 */
  hmCaseNumber:'粤ICP备2026022862号-3',

  /** 高埗 */
  gbCaseNumber:'粤ICP备2026024412号',

  /** 高埗 */
  dlCaseNumber:'粤ICP备2025514237号',
  /** 南浔 */
  nxCaseNumber:'',

   /** 三水 */
  ssCaseNumber:'',
  /** 多租户配置 */
  moreAccount: {
    'lt': {
      title: '智慧停车',
      logo: 'logo/logo.png'
    },
    'ds': {
      title: '铼停智慧停车',
      logo: 'logo/ds/logo.png'
    },
    'yxjf': {
      title: '云霄建发智慧停车',
      logo: 'logo/ds/logo.png'
    },
    'sw': {
      title: '邵武智慧停车',
      logo: 'logo/sw/logo-sw.png'
    },
    'js': {
      title: '京山智慧停车',
      logo: 'logo/js/logo.png'
    },
    'st': { // 弃用
      title: '商汤智慧停车',
      logo: 'logo/st/logo.png'
    },
    'mh': {
      title: '联创智云',
      logo: 'logo/mh/logo.png'
    },
    'ct': {
      title: '智慧停车',
      logo: ''//'logo/logo.png'
    },
    'rh': {
      title: '酒都智慧停车',
      logo: 'logo/rh/logo.png'
    },
    'zy': {
      title: '遵义智慧停车',
      logo: 'logo/zy/logo.png'
    },
    'hrg': {
      title: '华榕智慧停车',
      logo: 'logo/hrg/logo.png'
    },
    'yb': {
      title: '云泊停智慧停车',
      logo: 'logo/yb/logo.png'
    },
    'fa': {
      title: '福安市智慧停车',
      logo: 'logo/fa/logo.png'
    },
    'yx': {
      title: '云霄智慧停车',
      logo: 'logo/yx/logo.png'
    },
    'mw': {
      title: '马尾城市停车',
      logo: 'logo/mw/logo.png'
    },
    'lk': {
      title: '乐控智慧停车',
      logo: 'logo/lk/logo.png'
    },
    'fzmh': {
      title: '首邑滨城停车',
      logo: 'logo/fzmh/logo.png'
    },
    'hl': {
      title: '城捷泊车',
      logo: 'logo/hl/logo.png'
    },
    'fsdl': {
      title: '佛山大沥',
      logo: 'logo/fsdl/logo.png'
    },
    'zt': {
      title: '中堂智慧停车',
      logo: 'logo/zt/logo.png'
    },
    'hm': {
      title: '虎门智慧停车',
      logo: 'logo/hm/logo.png'
    },
    'gb': {
      title: '高埗智慧停车',
      logo: 'logo/gb/logo.png'
    },
    'dl': {
      title: '大朗智慧停车',
      logo: 'logo/dl/logo.png'
    },
    'nx': {
      title: '南浔智慧停车',
      logo: ''
    },
    'ss': {
      title: '三水智慧停车',
      logo: 'logo/ss/logo.png'
    }
  }
}
